module.exports = __webpack_public_path__ + "img/sm-x-o.40ae7794.svg";